import React from 'react';
import BannerImg from '../../../../../../assets/images/banner.png';

export const Banner = () => <img src={BannerImg} alt="banner" className="w-full" />;
